import md5 from 'md5';
import cookie from './cookie';

export default function () {
  let userId = cookie.get('cscUserId');

  if (!userId) {
    userId = md5(new Date().getTime() * Math.random());
    cookie.set('cscUserId', userId);
  }
  return userId;
}



// WEBPACK FOOTER //
// ./src/utils/get-anonymous-user-id.js